module.exports = __webpack_public_path__ + "static/media/stun.9dfae759.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/statusEffects/stun.svg
// module id = 148
// module chunks = 0